import { render, staticRenderFns } from "./Recording.vue?vue&type=template&id=42a0c76a&"
import script from "./Recording.vue?vue&type=script&lang=ts&"
export * from "./Recording.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports